export function getTokenScope(url: string): 'auth' | 'workspace' {
  // List all workspace-scoped endpoints
  const workspaceEndpoints = [
    '/projects',
    '/favorites',
    '/staff-members' ,
     '/issues/create', 
     '/issues' , 
     'attachment',
     'queues', 
     'comments' ,
     'market-places',
    'integrations',
    'clients',
    'workflows',
    'issue-types',
    'issue-type-icons',
    ];

  // If URL matches any workspace endpoint
  if (workspaceEndpoints.some(endpoint => url.includes(endpoint))) {
    return 'workspace';
  }
  // Default: use auth token
  return 'auth';
}